module.exports = "<div>\r\n  <div class=\"inner\">\r\n        <img src=\"..\\assets\\Oops.png\" width=\"50px\" height=\"50px\">\r\n        <div class=\"md-padding-top\">\r\n          <p>Something went wrong...</p>\r\n        </div>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// J:/Develop/Plumit Maintenance/src/app/page-not-found/page-not-found.component.html
// module id = ../../../../../src/app/page-not-found/page-not-found.component.html
// module chunks = main